import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="quote-item"
export default class extends Controller {
  static values = { 
    name: String
  }

  connect() {
    // Enhance the link with modal behavior
    this.element.addEventListener('click', this.handleClick.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    // Only prevent default if we can show the modal
    const frame = document.getElementById('add_item_modal_frame');
    
    if (frame && this.nameValue) {
      event.preventDefault();
      this.openModal();
    }
    // Otherwise, let the link work normally (fallback to quote request page)
  }

  openModal() {
    // Construct the modal URL
    const modalUrl = `/quote_requests/add_item_modal?name=${encodeURIComponent(this.nameValue)}`;
    
    // Use Turbo to fetch and display the modal
    const frame = document.getElementById('add_item_modal_frame');
    if (frame) {
      frame.src = modalUrl;
    }
  }
}